<template>
  <div class="tradesman-sorcelist">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加来源</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="添加来源"
           @on-ok="createBrand()"
           :loading="loading">
      <Form :model="skill"
            ref="brandValidate"
            action="javascript:void(0)">
        <FormItem label="来源名称">
          <Input v-model="skill.title"
                 placeholder="输入来源名称..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="修改来源"
           @on-ok="updateBrand()"
           :loading="loading">
      <Form :model="skill"
            ref="brandValidate"
            action="javascript:void(0)">
        <FormItem label="来源名称">
          <Input v-model="skill.title"
                 placeholder="输入来源名称..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
      
      <script>
export default {
  name: 'tradesman-sorcelist',
  data () {
    return {
      loading: true,
      dataloading: true,
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '标题',
          key: 'title',
          fixed: 'left'
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showEditInfo(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      skill: {
        name: '',
        status: '1',
      },
      formItem: {

      },
      showModalStatus: false,
      showEditInfoStatus: false,
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.tradesmansorce.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].status = this.tablelist[i].status == 1 ? "正常" : "禁用";
          }
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand (name) {
      this.$api.tradesmansorce.create({ title: this.skill.title }).then(res => {
        if (res.code == 200) {
          this.showModalStatus = !this.showModalStatus;
          this.skill.title = '';
          this.getTableList();
        }
      });
      this.loading = false
      this.$nextTick(() => { this.loading = true; });
    },
    //展开修改
    showEditInfo: function (index) {
      this.skillid = index;
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.tradesmansorce.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.skill.title = res.result.title;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => { this.loading = true; });
      });
    },
    // 修改名称
    updateBrand: function (name) {
      this.$api.tradesmansorce.edit({ id: this.skillid, title: this.skill.title }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.showEditInfoStatus = !this.showEditInfoStatus;
          this.getTableList();
        }
        this.loading = false;
        this.$nextTick(() => { this.loading = true; });
        this.showCreateStatus = !this.showCreateStatus;
      });
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.tradesmansorce.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
  },
}
      </script>
      